import { useState } from "react";
import { notification } from "antd";
import { Product, ProductAdd } from "@/types/product";
import { productAdd } from "@/apis/product";
import { useTranslation } from "react-i18next";
import errorCodes from "@/apis/error";

type Add = (props: ProductAdd) => Promise<Product>

type IUseProductAdd = () => [ boolean, { add: Add } ]

const useProductAdd:IUseProductAdd = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false)

  const add: Add = (props) => {
    setLoading(true)
    return new Promise((resolve) => {
      productAdd({...props, code: props.code.trim()})
        .then((info) => {
          notification.success({ placement: 'top', message: t('common.addSuccess') });
          setLoading(false)
          resolve(info)
        })
        .catch((err) => {
          notification.error({ placement: 'top', message: t('product.addFailed'), description: errorCodes[err] || err })
        })
        .finally(() => {
          setLoading(false)
        })
    })
  }

  return [loading, { add }]
}

export default useProductAdd;